import React from "react";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import cookieStorage from "../../utils/cookieStorage";
import { useContentSetting } from "../../Hooks/ContentSetting";
import { Tooltip } from "@mui/material";

export default function ExamNotification() {
  const today = new Date().toISOString().split("T")[0];
  const skippedDate = cookieStorage.getItem("testSkipped");
  const { initSettings, setInitSettings } = useContentSetting();

  const handleClick = () => {
    setInitSettings((old) => ({ ...old, isExam: true }));
  };

  return (
    <div>
      {initSettings.examination && skippedDate && skippedDate === today && (
        <Tooltip title="Pending Exam">
          <button
            className="header-button-action examination"
            onClick={handleClick}
          >
            <NotificationsActiveIcon />
          </button>
        </Tooltip>
      )}
    </div>
  );
}
